<template>
  <transition enter-active-class="bounceInRight" leave-active-class="bounceOutRight">
    <div class="real-time-alarm x-flex-y animated" v-if="showModal">
      <div class="title">
        <i class="x-weight-content">{{ title }}</i>
        <i class="iconfont x-grey-text iconshanchu" @click="showModal = false"></i>
      </div>
      <rendering v-if="message" class="x-flex-one" :render="message"></rendering>
    </div>
  </transition>
</template>

<script>
import i18n from '@/i18n/index.js';
import rendering from '../render.js';
export default {
  components: {
    rendering
  },
  props: {
    title: {
      type: String,
      default: () => i18n.t('HT.alarmMessage')
    },
    message: {
      type: Function,
      default: () => {
        return Function;
      }
    }
  },

  data() {
    return {
      showModal: false
    };
  },
  methods: {
    hide() {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.real-time-alarm {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 3;
  width: 360px;
  max-height: 280px;
  border-radius: 4px;
  background-color: #fff;
  animation-duration: 0.6s;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 20px;
    border-bottom: 1px solid #d7dde7;

    .iconfont {
      cursor: pointer;
    }
  }
}
</style>
